import { DateTime } from "luxon";
import { calculateOffset } from './loadObject'
class Action{
    type;
    status;
    desc;
    actionIndex;
    constructor (actionObject, onsite){
        this.type = actionObject.type;
        this.status = actionObject.dispatched ? onsite ? "Onsite" : "Dispatched" : "NotDispatched";
        this.desc = actionObject.desc;
        this.actionIndex = actionObject.actionIndex;
    }
}
export class TaskObject{
    id;
    address;
    apptTime;
    apptDate;
    actions;
    startOffset;
    isTask;
    width;
    currentTask;
    hasUndispatchedAction;
    constructor (taskObject, timelineStartInMills, taskOffset){
        this.isTask = true;

        this.id = taskObject.id;
        this.apptTime = taskObject.apptTime;
        this.apptDate = taskObject.apptDate;
        this.address = taskObject.address;
        this.currentTask = taskObject.currentTask;
        this.hasUndispatchedAction = taskObject.hasUndispatchedAction;
        const actionsArray  = [];
        for(const action of taskObject.actionsArray){            
            actionsArray.push(new Action(action, taskObject.onSite));
        }
        this.actions = actionsArray;
        this.width = actionsArray.length * 14;

        // Left Border 
        // const currentTimeInMills =  currentTimeRef && currentTimeRef.current ? currentTimeRef.current.toMillis() : null;
        if(taskOffset === null){
            const timezone = taskObject.address && taskObject.address.timezone ? taskObject.address.timezone : "America/Chicago";
            this.startOffset = calculateOffset(DateTime.fromFormat(
                `${this.apptDate} ${this.apptTime || '00:00 AM'}`,
                "MM/dd/yy hh:mm a",
                { zone: timezone,
                    locale: "en-US"  
                }
            ).toMillis(), timelineStartInMills);
        }else{
            this.startOffset = taskOffset;
            // let leftBorder = currentTimeInMills && currentTimeInMills > lastSpecifiedActionTime ? currentTimeInMills : lastSpecifiedActionTime;
            // if(this.apptDate){
            //     try {
            //         const timezone = taskObject.address && taskObject.address.timezone ? taskObject.address.timezone : "America/Chicago";
            //         leftBorder = Math.max(leftBorder, DateTime.fromFormat(
            //             `${this.apptDate} ${this.apptTime || '00:00 AM'}`,
            //             "MM/dd/yy hh:mm a",
            //             { zone: timezone}
            //         ).toMillis())
                    
                    
            //     } catch (error) {   
            //     }
            // }
            // const offsetByLeftBorder = calculateOffset(leftBorder, timelineStartInMills);
            // this.startOffset = offsetByLeftBorder;
        }
        
        

    }

}

